import { HomeownersContact } from "./HomeownersContact.page";

export default HomeownersContact;
